import React from "react";

const Tooltip = ({ text, children }) => {
  return (
    <div className="relative group inline-flex">
      {children}
      <div
        className="fixed z-[9999] px-2 py-1 text-sm text-white bg-black shadow-md
                   opacity-0 group-hover:opacity-100
                   transition-opacity duration-200
                   pointer-events-none"
        style={{ transform: "translate(-50%, -120%)" }}
      >
        {text}
      </div>
    </div>
  );
};

export default Tooltip;
